export var imageRenditions = {
  desktopL: {
    w: '484',
    h: '620'
  },
  desktop: {
    w: '414',
    h: '530'
  },
  tabletL: {
    w: '414',
    h: '530'
  },
  tabletP: {
    w: '324',
    h: '414'
  },
  mobile: {
    w: '375',
    h: '485'
  }
};